/**
  * 获取Blob
  * @param {stirng} base64
  */
export function getBlob(base64) {
  return b64toBlob(getData(base64), getContentType(base64))
}

/**
 * 获取文件类型
 * @param {string} base64
 */
function getContentType(base64) {
  // 正则表达式筛选出文件类型
  // return /data:([^;]*);/i.exec(base64)[1];
  const type = base64.split(';')[0]
  const typeData = type.split(':')[1]
  return typeData
}

/**
 * 获取base64中的数据
 * @param {string} base64
 */
function getData(base64) {
  return base64.substr(base64.indexOf('base64,') + 7, base64.length)
}

/**
 * base64转Blob
 * @param {string} b64Data
 * @param {string} contentType
 * @param {number} sliceSize
 */
function b64toBlob(b64Data, contentType, sliceSize) {
  contentType = contentType || ''
  sliceSize = sliceSize || 512

  const byteCharacters = atob(b64Data)
  const byteArrays = []

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize)
    const byteNumbers = new Array(slice.length)
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i)
    }
    const byteArray = new Uint8Array(byteNumbers)
    byteArrays.push(byteArray)
  }
  const blob = new Blob(byteArrays, { type: contentType })
  return blob
}
